import { IMAGES } from "@/data/site";

// Giveaway configuration — edit values here anytime.
export const GIVEAWAY = {
  goalUsd: 1500000,
  // Countdown deadline (UTC). Placeholder — change to your real end date.
  endDate: "2026-09-01T00:00:00Z",
  wallet: "6u5gmVYBdQ76vbRitBFer2TCAincUMwJeynJ3hJSiP9F",
  currencies: ["SOL", "USDC (SPL)"],
  network: "Solana Network",
  mainSite: "https://TheGreaterBull.com",
  logo: "https://customer-assets-m6fa6gv7.emergentagent.net/job_greater-bull/artifacts/eqmgzuyh_The%20Greater%20Bull%20official.png",
};

export const PRIZES = [
  {
    id: "lambo",
    rank: "Grand Prize",
    title: "Lamborghini Urus",
    subtitle: "The apex predator of SUVs",
    img: "https://static.prod-images.emergentagent.com/jobs/864859fa-1dc3-41ba-83da-16c24a7d25a3/images/6e361cff6bb2fa051e346e5e30ee8a893314ae434584393da14717553bf9bd96.png",
    accent: "gold",
  },
  {
    id: "cash",
    rank: "Second Prize",
    title: "$25,000 in Cash",
    subtitle: "Cold, hard, life-changing liquidity",
    img: "https://images.unsplash.com/photo-1593672715438-d88a70629abe?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    accent: "ember",
  },
  {
    id: "dubai",
    rank: "Third Prize",
    title: "Dubai Trip for Two",
    subtitle: "Flights + luxury, on the house",
    img: "https://images.unsplash.com/photo-1652707228067-25672fa0b082?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    accent: "solana",
  },
];

// Must mirror backend TICKET_TIERS
export const TICKETS = [
  { tier: 1, name: "Spark", price: 85, entries: 1, accent: "solana", perks: ["1 entry into the draw", "Supporter badge", "Community shoutout"] },
  { tier: 2, name: "Blaze", price: 225, entries: 3, accent: "ember", perks: ["3 entries into the draw", "3x your winning odds", "Priority community access"] },
  { tier: 3, name: "Inferno", price: 500, entries: 8, accent: "blood", popular: true, perks: ["8 entries into the draw", "8x your winning odds", "OG holder recognition"] },
  { tier: 4, name: "Legendary", price: 2500, entries: 50, accent: "gold", perks: ["50 entries into the draw", "Best odds — 50x", "Legendary status + all perks"] },
];

export const CHAPTERS = [
  {
    no: "01",
    title: "Marketing War Chest",
    body: "We're raising $1,500,000 in pure marketing capital — the fuel to take The Greater Bull from meme to movement. No dilution, no games. Every dollar sharpens the charge.",
  },
  {
    no: "02",
    title: "Top-Tier KOLs & Influencers",
    body: "We onboard the most respected Key Opinion Leaders and pay professional social media influencers to put $TGB in front of millions of the right eyes across X, YouTube and Telegram.",
  },
  {
    no: "03",
    title: "Heavy Volume & Advertising",
    body: "Aggressive volume boosts, relentless shilling and premium advertising placements keep $TGB trending on Dexscreener and impossible to ignore across the entire space.",
  },
  {
    no: "04",
    title: "Liquidity Backing",
    body: "A portion of every dollar raised is committed to backing up liquidity for the coin — a stronger floor, deeper pools, and a more resilient chart for every holder.",
  },
];

export { IMAGES };
